module.exports = __webpack_public_path__ + "static/img/banner1.3b06681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/banner1.png
// module id = ylM/
// module chunks = 0